import { FC, useEffect } from "react";

import { ISettingOptions } from "../../../types/interfaces";

import styles from "../headerBtn.module.scss";

const options = [
  { value: "reportId", label: "№ отчета" },
  { value: "date", label: "Дата" },
  { value: "review", label: "Проверка" },
  { value: "delivery", label: "Статус доставки" },
  { value: "rate", label: "Оценка" },
  { value: "geo", label: "Гео" },
  { value: "photo", label: "Фото" },
  { value: "contract", label: "Контракт" },
  { value: "chain", label: "Сеть" },
  { value: "region", label: "Регион" },
  { value: "address", label: "Адрес" },
  { value: "project", label: "Проект" },
  { value: "sv", label: "Супервайзер" },
  { value: "vsv", label: "Виртуальный супервайзер" },
  { value: "merch", label: "Мерчендайзер" },
  { value: "clientId", label: "ID ТТ клиента" },
  { value: "trainee", label: "Стажер" },
  { value: "refined", label: "Нарушитель " },
  { value: "notChecked", label: "Не проверен" },
];

const AdminReportsSettingsSection: FC<ISettingOptions> = ({
  setSelectedSettings,
  selectedSettings,
  setIsCheckedFullInfo,
  isCheckedFullInfo,
}) => {
  const handleChangeCheckbox = (name: string) => {
    const updatedSettings = selectedSettings.includes(name)
      ? selectedSettings.filter((elem: string) => elem !== name)
      : [...selectedSettings, name];
      setSelectedSettings(updatedSettings);
    setIsCheckedFullInfo(updatedSettings.length === options.length);
  };

  const handleChangeFullInfoCheckbox = () => {
    if (!isCheckedFullInfo) {
      const allSettings = options.map((option) => option.value);
      setSelectedSettings(allSettings);
    } else {
      setSelectedSettings([]);
    }
    setIsCheckedFullInfo(!isCheckedFullInfo);
  };

  useEffect(()=>{
    setIsCheckedFullInfo(selectedSettings.length === options.length);
    // eslint-disable-next-line
  },[]);

  return (
    <div className={styles.settings__block_info}>
      <div className={styles.check__list_block}>
        {options.map((option) => (
          <div key={option.value} className={styles.check__list_elem}>
            <label className={styles.checkbox__container}>
              <input
                checked={selectedSettings.includes(option.value)}
                type="checkbox"
                onChange={() => handleChangeCheckbox(option.value)}
              />
              <span className={styles.multi__reason_checkmark}></span>
            </label>
            {option.label}
          </div>
        ))}
        <div className={styles.check__list_elem}>
          <label className={styles.checkbox__container}>
            <input
              type={"checkbox"}
              onChange={handleChangeFullInfoCheckbox}
              checked={isCheckedFullInfo || (options.length === selectedSettings.length)}
            />
            <span className={styles.multi__reason_checkmark}></span>
          </label>
          Все
        </div>
      </div>
    </div>
  );
};

export default AdminReportsSettingsSection;
